import React from 'react';
import { HashRouter, Route, Routes } from 'react-router-dom';
import ErrorBoundary from '@/component/helper/ErrorBoundary';
import { GlobalStyle } from '@/component/helper/GlobalStyle';
import ApiError from '@/component/route/ApiError';
import Config from '@/component/route/Config';
import NotFound from '@/component/route/NotFound';
import { COMMON_ROUTES } from '@/config/route';
import { StoreProvider } from './redux/store';
import RWDPageLayout from './component/composite/RWDPageLayout';
import AppInitProvider from './component/helper/AppInitProvider';
import AuthInitProvider from './component/helper/AuthInitProvider';
import CareRequirement from './page/CareRequirement';
import ContactInfo from './page/ContactInfo';
import Contract from './page/Contract';
import DateAndTime from './page/DateAndTime';
import DetailConfirmation from './page/DetailConfirmation';
import Entry from './page/Entry';
import Hospital from './page/Hospital';
import HospitalConfirmation from './page/HospitalConfirmation';
import MarketingChannel from './page/MarketingChannel';
import NotesAndAgreement from './page/NotesAndAgreement';
import PatientInfo from './page/PatientInfo';
import TransferInstruction from './page/TransferInstruction';
import { APP } from './config/app';
import { EXTERNAL_LINK_URL } from './config/externalLinkUrl';
import makeGraphqlServer from '../mockApi/graphqlServer';
import makeServer from '../mockApi/mirageServer';
/* create mock API server for development testing */
const ENV = process.env.ENV.TARGET_ENV;
if ((ENV === 'local' || ENV === 'dev') && process.env.ENV.TEST_SCENARIO) {
    const TEST_SCENARIO = process.env.ENV.TEST_SCENARIO;
    makeServer('development', TEST_SCENARIO);
    makeGraphqlServer();
}
function App() {
    return (<StoreProvider>
      <HashRouter basename=''>
        <GlobalStyle />
        <ErrorBoundary customerServiceUrl={EXTERNAL_LINK_URL.FB_CUSTOMER_SERVICE}>
          <AuthInitProvider>
            <AppInitProvider>
              <Routes>
                <Route path={APP.ROUTES.ENTRY} element={<Entry />}/>
                <Route path={APP.ROUTES.MARKETING_CHANNEL} element={<MarketingChannel />}/>
                <Route path={APP.ROUTES.CONTACT_INFO} element={<ContactInfo />}/>
                <Route path={APP.ROUTES.CONTRACT} element={<Contract />}/>
                <Route path={APP.ROUTES.HOSPITAL} element={<Hospital />}/>
                <Route path={APP.ROUTES.HOSPITAL_CONFIRMATION} element={<HospitalConfirmation />}/>
                <Route path={APP.ROUTES.PATIENT_INFO} element={<PatientInfo />}/>
                <Route path={APP.ROUTES.CARE_REQUIREMENT} element={<CareRequirement />}/>
                <Route path={APP.ROUTES.NOTES_AND_AGREEMENT} element={<NotesAndAgreement />}/>
                <Route path={APP.ROUTES.DATE_AND_TIME} element={<DateAndTime />}/>
                <Route path={APP.ROUTES.DETAIL_CONFIRMATION} element={<DetailConfirmation />}/>
                <Route path={APP.ROUTES.TRANSFER_INSTRUCTION} element={<TransferInstruction />}/>

                <Route path={COMMON_ROUTES.CONFIG} element={<RWDPageLayout isLoading={false}>
                      <Config APP={APP} EXTERNAL_LINK_URL={EXTERNAL_LINK_URL}/>
                    </RWDPageLayout>}/>
                <Route path={`${COMMON_ROUTES.API_ERROR}/:errCode`} element={<RWDPageLayout isLoading={false}>
                      <ApiError customerServiceUrl={EXTERNAL_LINK_URL.FB_CUSTOMER_SERVICE}/>
                    </RWDPageLayout>}/>
                <Route path={COMMON_ROUTES.NOT_FOUND} element={<RWDPageLayout isLoading={false}>
                      <NotFound redirectRoute={APP.ROUTES.ENTRY}/>
                    </RWDPageLayout>}/>
              </Routes>
            </AppInitProvider>
          </AuthInitProvider>
        </ErrorBoundary>
      </HashRouter>
    </StoreProvider>);
}
export default App;
